<template>
  <div class="">
    <ZnBreadcrumb />
    <div
      class="main-content"
      v-title
      data-title="订单统计管理_试剂采购库存管理系统"
    >
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div class="search-wrapper">
              <el-input
                v-model="alias"
                placeholder="请输入关键字查询"
                prefix-icon="el-icon-search"
                @keyup.enter.native="reagentList()" style="width: 200px"
              />
            </div>
            <div class="search-wrapper">
              <el-select v-model="nickName" placeholder="下单人" @change="reagentList()" style="width: 120px">
                <el-option label="全部" value=""/>
                <el-option v-for="(item, index) in orderUsers" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="search-wrapper">
              <el-select v-model="orderStatus" placeholder="订单状态" @change="reagentList()" style="width: 110px">
                <el-option
                    v-for="item in orderOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-wrapper">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 300px"
                  v-model="queryTime"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="search-wrapper">
              <el-button size="small" type="primary" @click="reagentList()">
                快速查询
              </el-button>
            </div>
            <div class="search-wrapper">
              <el-button size="small" @click="handleExportCensus()">
                导出Excel
              </el-button>
            </div>
          </li>
        </ul>
        <div>
          <el-row :gutter="24" style = "margin-top: 20px;">
            <el-col :span="3" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">总金额：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="orderAmount.totalAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="3" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">待审核：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="orderAmount.waitAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="2" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">通过：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="orderAmount.successAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="2" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">驳回：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="orderAmount.failAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="2" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">取消：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="orderAmount.cancelAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="3" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">采购频次：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="orderAmount.reagentNum" :disabled="true"></el-input></span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div>
        <el-row :gutter="0" style="float: right;">
          <el-col :span="23" style="margin: 10px 20px; height: 32px; line-height: 32px;">
            <span>
              <el-button size="small" type="primary" @click="generatorTable()">
              生成分析图表
            </el-button>
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="table-container" style="padding-top: 0px">
        <el-table
          :data="recordList"
          max-height="600px"
          row-key="id"
          :expand-row-keys="expands"
          @expand-change="expandsFun"
          :header-cell-style="{
            background: '#F8FAFC',
            color: '#000000',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无记录</p>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div style="margin-left: 10px;margin-bottom: 10px">
                <el-row>
                  <el-col :span="4">
                    <span style="color: #000; font-weight: 700"> 订单编号：</span>
                    <span>{{ props.row.lockerOrders.orderNo }}</span>
                  </el-col>
                  <el-col :span="4">
                    <span style="color: #000; font-weight: 700">商品编码：</span>
                    <span>{{ props.row.goodsNo }}</span>
                  </el-col>

                  <el-col :span="12">
                    <span style="color: #000; font-weight: 700">规格详情：</span>
                    <span>{{ props.row.specNames }}</span>
                  </el-col>
                </el-row>
              </div>
              <div style="margin-left: 10px;margin-bottom: 10px">
              </div>
              <div style="margin-left: 10px;">
                <el-row>
                  <el-col :span="4">
                    <span style="color: #000; font-weight: 700">存储位置：</span>
                    <span>{{ props.row.cabinetName }}</span>
                  </el-col>
                  <el-col :span="4">
                    <span style="color: #000; font-weight: 700">物流公司：</span>
                    <span>{{ props.row.lockerOrders.expressName }}</span>
                  </el-col>
                  <el-col :span="12">
                    <span style="color: #000; font-weight: 700">物流单号：</span>
                    <span>{{ props.row.lockerOrders.expressNo }}</span>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" label="试剂名称" sortable :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="casNo" label="CAS号">
          </el-table-column>
          <el-table-column label="采购剂量" width="80px">
            <template v-slot="scope">
              <span v-if="scope.row.lockerOrders.orderType == 1">
                {{ scope.row.packageType }}
              </span>
              <span v-if="scope.row.lockerOrders.orderType == 0">
                {{ scope.row.weight }} {{ unit(scope.row.weightUnit) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="supplierBrand" label="品牌" width="100px">
            <template v-slot="scope">
              <span v-if="null != scope.row.supplierBrand">{{ scope.row.supplierBrand }}</span>
              <span v-else>{{ scope.row.supplierName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="80px">
          </el-table-column>
          <el-table-column prop="num" label="采购量" width="80px">
          </el-table-column>
          <el-table-column prop="salesPrice" label="单价" width="100px">
            <template v-slot="scope">
              <span v-if="scope.row.salesPriceTask">{{ scope.row.salesPriceTask/scope.row.num|numFilter }}元</span>
              <span v-else>{{ scope.row.salesPrice/scope.row.num }}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="运费" width="100px">
            <template v-slot="scope">
              <span >{{ scope.row.lockerOrders.freightActual }}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="总金额" width="100px">
            <template v-slot="scope">
              <span v-if="scope.row.salesPriceTask">{{ (scope.row.salesPriceTask + scope.row.lockerOrders.freightActual).toFixed(2) }}元</span>
              <span v-else>{{ (scope.row.salesPrice +scope.row.lockerOrders.freightActual).toFixed(2) }}元</span>
            </template>
          </el-table-column>

          <el-table-column prop="lockerOrders.nickName" label="购买人" width="120px">
          </el-table-column>
          <el-table-column
            prop="lockerOrders.auditTime"
            label="购买时间"
            sortable
            width="160px"
          >
          </el-table-column>

          <el-table-column label="审批状态" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.lockerOrders.auditStatus }}</span>
              <el-popover
                placement="top-start"
                width="200"
                trigger="click"
                :content="scope.row.refusalReason"
                v-if="scope.row.auditStatus == '已拒绝'"
                style="margin-left: 5px"
              >
                <i slot="reference" class="el-icon-warning"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              <span>{{ scope.row.lockerOrders.orderStatus }}</span>
              <el-popover
                placement="top-start"
                width="200"
                trigger="click"
                :content="scope.row.calReason"
                v-if="scope.row.orderStatus == '订单取消'"
                style="margin-left: 5px"
              >
                <i slot="reference" class="el-icon-warning"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="开票状态">
            <template slot-scope="scope">
              <span v-if="scope.row.invoiceNum">
                <el-tooltip class="item" effect="dark" :content="'票号：'+scope.row.invoiceNum" placement="top-start">
                <span v-if="scope.row.invoiceNum">已开票</span>
              </el-tooltip>
              </span>
              <span v-else>未开票</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          :pager-count="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagedata.pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pagedata.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      amount:{
        orderAmount:null,
        successOrder:null,
        failOrder:null,
        waitOrder:null,
        orderBuy:null,
      },
      orderAmount:{
        //总金额
        totalAmount:null,
        //待审核金额
        waitAmount:null,
        //通过金额
        successAmount:null,
        //驳回金额
        failAmount:null,
        //采购量
        reagentNum:null,
        //取消金额
        cancelAmount: null
      },
      searchData: {},
      orderUsers: [],
      nickName: null,
      queryTime: [],
      expands: [],
      OrdersDetails: [],
      orderStatus: "",
      auditStatus: "",
      alias: "",
      orderOptions: [
        {
          value: "",
          label: "请选择",
        },
        {
          value: "1",
          label: "待发货",
        },
        {
          value: "2",
          label: "已发货",
        },
        // {
        //   value: "3",
        //   label: "待入库",
        // },
        {
          value: "4",
          label: "已收货",
        },
        {
          value: "5",
          label: "订单取消",
        },
        {
          value: "6",
          label: "待确认",
        },
      ],
      auditOptions: [
        // {
        //   value: '',
        //   label: '全部',
        // },
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "待审核",
        },
        {
          value: "2",
          label: "已通过",
        },
        {
          value: "3",
          label: "已拒绝",
        },
      ],
      recordList: [],
      total: 0,
      totalpage: 0,
      pagedata: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.reagentList();
    //this.getOrderStat();
    this.getOrderUser();
  },
  filters:{
    numFilter (value) {
      // 截取当前数据到小数点后三位
      return Math.floor(value*100)/100;
    },
  },
  methods: {
    generatorTable(){
      this.$router.push("/orderDataAnaly");
    },
    handleExportCensus(){
      var startTime = null;
      var endTime = null;
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      const params = this.searchData;
      params.alias = this.alias.trim();
      params.orderStatus = this.orderStatus;
      params.startTime = startTime;
      params.endTime = endTime;
      params.nickName = this.nickName;
      const resp = this.$apiFetch
          .download("/lockerOrdersItems/exportExecl", params)
          .then((resp) => this.downloadFile(resp,'订单采购统计表'));
    },
    orderBizStatistics(){
      var startTime = null;
      var endTime = null;
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      const params = this.searchData;
      params.alias = this.alias.trim();
      params.orderStatus = this.orderStatus;
      params.startTime = startTime;
      params.endTime = endTime;
      params.nickName = this.nickName;
      this.$apiFetch
          .get(`/lockerOrdersItems/orderBizStatistics`,
              params)
          .then((res) => {
            this.orderAmount = res.data;
          });
    },
    getOrderUser(){
      this.$apiFetch
          .get(`/lockerUser/queryAllUserTask`)
          .then((res)=>{
            this.orderUsers = res.data;
          })
    },
    getOrderStat(){
      this.$apiFetch
        .get(`/lockerOrders/orderStatistics`)
        .then((res)=>{
          console.log(res)
          this.amount.orderAmount = res.data.orderAmount;
          this.amount.successOrder = res.data.successOrder;
          this.amount.failOrder = res.data.failOrder;
          this.amount.waitOrder = res.data.waitOrder;
          this.amount.orderBuy = res.data.orderBuy;
        })
    },
    // 分页 size 改变
    handleSizeChange(val) {
      this.pagedata.pageSize = val;
      // this.searchData.pageNum = this.pagedata.pageNum;
      // this.searchData.pageSize = this.page.pageSize
      this.reagentList();
    },
    // 当前 页码 改变
    handleCurrentChange(val) {
      this.pagedata.pageNum = val;
      // this.searchData.pageNum = this.pagedata.pageNum;
      // this.searchData.pageSize = this.page.pageSize
      this.reagentList();
    },

    // expands 只展开一行
    expandsOneRow(row, expandedRows) {
      if (expandedRows.length) {
        //说明展开了
        this.expands = [];
        if (row) {
          this.expands.push(row.id); //只展开当前行id
        }
      } else {
        //说明收起了
        this.expands = [];
      }
    },

    // 获取试剂详情展开按钮
    expandsFun(row, expandedRows) {
      if (this.expands.includes(row.id)) {
        //已经展开的话，就关闭，移除在expands中的key
        this.expands = this.expands.filter((val) => val !== row.id);
      } else {
        this.expands.push(row.id);
        this.expandsOneRow(row, expandedRows); // 收起
      }
    },

    changePage(data) {
      this.pagedata.pageNum = data;
      this.reagentList();
    },
    // 单位
    unit(reagentWeightUnit) {
      //单位适配
      return reagentWeightUnit == 1
        ? "mL"
        : reagentWeightUnit == 2
        ? "g"
        : reagentWeightUnit == 3
        ? "mg"
        : reagentWeightUnit == 4
        ? "L"
        : reagentWeightUnit == 5
        ? "kg"
        : reagentWeightUnit == 6
        ? "KU"
        : reagentWeightUnit == 7
        ? "U"
        : "";
    },
    //试剂柜列表
    reagentList() {
      var startTime = null;
      var endTime = null;
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      let auditStatus = this.auditStatus;
      let orderStatus = this.orderStatus;
      let params = this.pagedata;
      params.orderStatus = orderStatus;
      params.alias = this.alias.trim();
      params.nickName = this.nickName;
      params.startTime = startTime;
      params.endTime = endTime;
      this.$apiFetch.get(`/lockerOrdersItems/listPage`, params).then((res) => {
        this.total = res.data.total;
        this.pagedata.pageNum = res.data.pageNum;
        this.totalpage = res.data.pages;
        res.data.list.map((item) => {
          if (
            item.lockerOrders.auditStatus == 1 &&
            item.lockerOrders.orderStatus == 1
          ) {
            item.lockerOrders.orderStatus = "-";
          }
          if (item.lockerOrders.auditStatus == 0) {
            item.lockerOrders.auditStatus = "-"; // 不需要审核
          } else if (item.lockerOrders.auditStatus == 1) {
            item.lockerOrders.auditStatus = "待审核";
          } else if (item.lockerOrders.auditStatus == 2) {
            item.lockerOrders.auditStatus = "已通过";
          } else if (item.lockerOrders.auditStatus == 3) {
            item.lockerOrders.auditStatus = "已拒绝";
          } else if (item.lockerOrders.auditStatus == 4) {
            item.lockerOrders.auditStatus = "洛济取消";
          } else if (item.lockerOrders.auditStatus == 10) {
            item.lockerOrders.auditStatus = "-";
          }
          if (item.lockerOrders.orderStatus == 0) {
            item.lockerOrders.orderStatus = "订单待确认";
          }else if (item.lockerOrders.orderStatus == 1) {
            item.lockerOrders.orderStatus = "待发货";
          } else if (item.lockerOrders.orderStatus == 2) {
            item.lockerOrders.orderStatus = "已发货";
          } else if (item.lockerOrders.orderStatus == 3) {
            // item.lockerOrders.orderStatus = "待入库";
            // item.lockerOrders.orderStatus = "已完成";
            item.lockerOrders.orderStatus = "已收货";
          } else if (item.lockerOrders.orderStatus == 4) {
            item.lockerOrders.orderStatus = "已收货";
            // item.lockerOrders.orderStatus = "已完成";
          } else if (item.lockerOrders.orderStatus == 5) {
            item.lockerOrders.orderStatus = "订单取消";
          }else if (item.lockerOrders.orderStatus == 6 && (item.lockerOrders.auditStatus == 2 || item.lockerOrders.auditStatus == "已通过")) {
            item.lockerOrders.orderStatus = "订单待确认";
          } else if (item.lockerOrders.orderStatus == 10) {
            item.lockerOrders.orderStatus = "洛济取消";
          }else {
            item.lockerOrders.orderStatus = "-";
          }
        });
        this.recordList = res.data.list;
      });

      this.orderBizStatistics();
    },
    goodsDetails(row) {
      let id = row.id;
      let price = row.payAmount;
      let No = row.orderNo;
      this.$router.push({ path: `goodsDetails/${id}?price=${price}&No=${No}` });
    },
    //我的选购
    myCart() {
      this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
        this.myCartNum = res.data;
      });
    },
  },
};
</script>
<style lang="less">
  .dataClass  .dataInput .el-input__inner {
    width: 110px;height: 30px;
    background-color: #f5f7fa;
    color: #606266;
  }
  .dataClass .el-color-picker__icon, .el-input, .el-textarea {
    width: auto;
  }
</style>
<style lang="less" scoped>
/*修改展开按钮的样式 start*/
/deep/ .el-table__expand-icon {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
/*2.展开按钮未点击的样式是加号带边框*/
/deep/ .el-table__expand-icon .el-icon-arrow-right:before {
  // content: "\e6d9";
  padding: 2px;
  color: #478aff;
  font-weight: 900;
}
/*3.展开按钮点击后的样式是减号带边框*/
/deep/ .el-table__expand-icon--expanded .el-icon-arrow-right:before {
  content: "\e6df";
  color: #478aff;
}
.bar_text {
  margin-right: 8px;
}
.no-date {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 148px;
  }
  p {
    color: #b1c4e2;
    font-size: 14px;
    line-height: 20px;
    margin-top: 14px;
    text-align: center;
  }
}

.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      display: flex;
      align-items: center;
      .search-wrapper{
        margin-right: var(--zng-gap);
        & > span{
          margin-right: 10px;
        }
        .el-input{
          width: 280px;
        }
      }
    }
    li.last {
      margin-left: 100px;
    }
  }
}
/deep/.el-table .cell {
  button {
    margin-right: 20px;
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
.el-popover {
  p {
    color: #333333;
    font-size: 12px;
    line-height: 17px;
    padding-bottom: 8px;
  }
  button {
    display: block;
    margin: 0 auto;
  }
}
</style>
